<template>
  <div class="store-profile-search filter-product-main-wrapper">
    <div class="modal-card filter-form">
      <section class="modal-card-body">
        <!-- we are doing repeat component because same structure but different position and design on mobile and desktop-->
         <filter-main-content :sort="sort" :sizes="sizes" :activesubcategory="activesubcategory" :categoryintensity="categoryintensity" :showheading="true"/>
      </section>
    </div>
  </div>
</template>
<script>
import FilterMainContent from "@/Components/Pages/PageComponents/StoreProfile/FilterMainContent";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    FilterMainContent
  },
  props: ['sort', 'sizes', 'activesubcategory', 'categoryintensity'],
  data() {
    return {
    };
  },
};
</script>
<style>
.section-search-results{
  min-height: 70vh;
}
.is-checkradio[type="checkbox"].no-bgcolor:hover,
.is-checkradio[type="checkbox"].no-bgcolor + label{
    background: #ffffff !important;
}
</style>